import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useStores } from "../../hooks/useStores";
import {
  SidebarContainer,
  NavWrapper,
  NavItem,
  NavItemText,
  BrandIcon,
  BrandContainer,
  NavItemIcon,
} from "./styled";
import { observer } from "mobx-react";
import LogoImg from "../../assets/logo/logo.png";
import { Avatar, MenuButton, MenuItem, Menu, MenuList } from "@chakra-ui/react";
import { Icon } from "../Icon";

type Props = {};

export enum MenuItemKeys {
  customers,
  reports,
  customersInactive,
  admins,
  settings,
}

export const Sidebar: React.FC<Props> = observer(() => {
  const { t } = useTranslation();
  const { session, ui } = useStores();
  const history = useHistory();

  const handleNavigateTo = useCallback(
    (key) => {
      ui.setActiveScreen(key);

      switch (key) {
        case MenuItemKeys.customers:
          history.push(`/admin/clients`);
          break;
        case MenuItemKeys.reports:
          history.push(`/admin/reports`);
          break;
        case MenuItemKeys.settings:
          history.push(`/admin/settings`);
          break;
      }
    },
    [history, ui]
  );

  return (
    <SidebarContainer isCollapsed={false}>
      <BrandContainer>
        <BrandIcon>
          <Avatar size="lg" src={LogoImg} alt={"Sabeda"} />
        </BrandIcon>
      </BrandContainer>
      <NavWrapper>
        <NavItem
          isActive={ui.activeScreen === MenuItemKeys.customers}
          onClick={() => handleNavigateTo(MenuItemKeys.customers)}
        >
          <NavItemIcon>
            <Icon iconName={"HiUsers"} />
          </NavItemIcon>
          <NavItemText>{t("nav.customers")}</NavItemText>
        </NavItem>

        <NavItem
          isActive={ui.activeScreen === MenuItemKeys.reports}
          onClick={() => handleNavigateTo(MenuItemKeys.reports)}
        >
          <NavItemIcon>
            <Icon iconName={"HiDocumentReport"} />
          </NavItemIcon>
          <NavItemText>{t("nav.reports")}</NavItemText>
        </NavItem>

        <NavItem
          isActive={ui.activeScreen === MenuItemKeys.settings}
          onClick={() => handleNavigateTo(MenuItemKeys.settings)}
        >
          <NavItemIcon>
            <Icon iconName={"HiCog"} />
          </NavItemIcon>
          <NavItemText>{t("nav.settings")}</NavItemText>
        </NavItem>
      </NavWrapper>
      <NavWrapper>
        <NavItem>
          <Menu>
            <MenuButton px={4} py={2}>
              <Avatar
                values={session.user?.name || []}
                alt={session.user?.name}
                extendend
              />
            </MenuButton>
            <MenuList>
              <MenuItem
                onClick={() => {
                  session.resetSession();
                }}
              >
                {t("nav.logout")}
              </MenuItem>
            </MenuList>
          </Menu>
        </NavItem>
      </NavWrapper>
    </SidebarContainer>
  );
});
